import { createContext, useContext } from 'react';

import {
  DEFAULT_WORKFLOW_SCALE_OPTIONS,
  type WorkflowScaleOptions,
} from '../../view/workflow/workflowScaleOptions';

export const WorkflowScaleContext = createContext<WorkflowScaleOptions>(
  DEFAULT_WORKFLOW_SCALE_OPTIONS,
);

export function useWorkflowScaleOptions(): WorkflowScaleOptions {
  return useContext(WorkflowScaleContext);
}
